export const CHANGE_PAGE_ID = "CHANGE_PAGE_ID";
export const CHANGE_PAGE_TITLE = "CHANGE_PAGE_TITLE";
export const CHANGE_LOGGED_IN = "CHANGE_LOGGED_IN";
export const CHANGE_PERIOD_REPORT_ID = "CHANGE_PERIOD_REPORT_ID";
export const CHANGE_PERIOD_REPORT_NAME = "CHANGE_PERIOD_REPORT_NAME";
export const CHANGE_ADMIN_NAVIGATOR_SECTION = "CHANGE_ADMIN_NAVIGTOR_SECTION";
export const CHANGE_ADMIN_LIST = "CHANGE_ADMIN_LIST";
export const CHANGE_ADMIN_FORM = "CHANGE_ADMIN_FORM";
export const CHANGE_ADMIN_ID = "CHANGE_ADMIN_ID";
export const CHANGE_THEME = "CHANGE_THEME";
export const CHANGE_THEME_TEXT_COLOR = "CHANGE_THEME_TEXT_COLOR";
export const CHANGE_CLIENT = "CHANGE_CLIENT";
export const CHANGE_SCAN_WINDOW_HIDE = "CHANGE_SCAN_WINDOW_HIDE";
export const CHANGE_REMAINING_CONTENT_Z_INDEX = "CHANGE_REMAINING_CONTENT_Z_INDEX";
export const CHANGE_AREA_UNIT = "CHANGE_AREA_UNIT";
export const CHANGE_FILTER = "CHANGE_FILTER";
export const CHANGE_DASHBOARD_SEARCH_CRITERIA = "CHANGE_DASHBOARD_SEARCH_CRITERIA";
export const CHANGE_QUERY_CONTEXT = "CHANGE_QUERY_CONTEXT";
export const CHANGE_DOCUMENT_BASKET = "CHANGE_DOCUMENT_BASKET";